import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import { LinkPanelItem } from './LinkPanelItem';
import { Grid } from '../../common/Grid';
import { H1 } from '../../text';
import LayoutContext, { MODERN_LAYOUT_COLLAPSE_WIDTH } from '../../../contexts/Layout';

export const LinkPanel = ({ contentItems = {}, followContentLink, heading, nodeTypeAlias = 'LinkPanel', width, hardWidth }) => {
    const { layout } = useContext(LayoutContext);

    const items = Object.values(contentItems).map((item, index) => (
        <LinkPanelItem
            {...item}
            index={index}
            key={`link-panel-item-${index}`}
            followContentLink={followContentLink}
            width={hardWidth <= MODERN_LAYOUT_COLLAPSE_WIDTH ? hardWidth : Math.floor(hardWidth * 0.5)}
            nodeTypeAlias={item.nodeTypeAlias}
        />
    ));

    return (
        <View
            style={StyleSheet.flatten(Styles.wrapper, { marginBottom: layout.styleGuide.componentSeparator, width })}
            dataSet={{ umbracoComponentName: nodeTypeAlias, spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})` }}
        >
            {!!heading && (
                <H1 style={{ marginBottom: layout.styleGuide.spacer3 }} text={heading} dataSet={{ spacerBottom: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})` }} />
            )}
            <Grid width={hardWidth} items={items} />
        </View>
    );
};

const Styles = StyleSheet.create({
    wrapper: {
        alignItems: 'center',
        backgroundColor: '#fff',
        justifyContent: 'center'
    }
});

LinkPanel.propTypes = {
    contentItems: PropTypes.object,
    heading: PropTypes.string
};
